import React from 'react';
import { UpdatesPage } from '../layouts/UpdatesPage';

const Page = () => <UpdatesPage title="Ricevi Aggiornamenti" />;
export default Page;
